import { useQuery, UseQueryOptions } from 'react-query';

import { OutputAnalysisStructure } from '../../models';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { CerebroApiEndpoints } from '../../utils/api';
import { QueryKeys } from '.';

export function useOutputAnalysisStructureQuery(
	guid: string | undefined,
	options?:
		| Omit<UseQueryOptions<OutputAnalysisStructure, unknown, OutputAnalysisStructure>, 'queryKey' | 'queryFn'>
		| undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Matching.OutputAnalysis(guid),
		() =>
			AxiosUtils.getResponseData<OutputAnalysisStructure>(
				api.get(CerebroApiEndpoints.Matching.OutputAnalysis(guid))
			),
		options
	);
}
